import { render } from "./PlayerDashboard.vue?vue&type=template&id=073020bc&scoped=true"
import script from "./PlayerDashboard.vue?vue&type=script&lang=js"
export * from "./PlayerDashboard.vue?vue&type=script&lang=js"

import "./PlayerDashboard.vue?vue&type=style&index=0&id=073020bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073020bc"]])

export default __exports__